<script>
import { mapGetters } from 'vuex'
import { useCases } from 'frontend-js-shared'

export default {
  computed: {
    ...mapGetters(['account', 'organizationSiteGroups']),
  },

  methods: {
    getRoutineApprovalPermissions({ routineApproval, routine } = {}) {
      return useCases.routineApprovals.getPermissions({
        routineApproval,
        routine,
        currentAccount: this.account,
        organizationSiteGroups: this.organizationSiteGroups,
      })
    },
  },
}
</script>
